<template>
  <ak-table :data="data" class="one-whole" bordered hoverable inset>
    <template #default="{ row }">
      <ak-table-column :width="300" field="name" label="Name" sortable>
        {{ row.name }}
      </ak-table-column>
      <ak-table-column field="tag" label="Tag" sortable>
        {{ row.tag }}
      </ak-table-column>
      <ak-table-column right mini>
        <ak-button size="tiny" @click="insertVariable(row)">
          <ak-icon type="plus" class="mr-tiny" />
          Insert
        </ak-button>
      </ak-table-column>
    </template>
  </ak-table>
</template>

<script>
import { defineComponent } from 'vue'
import Table from '../table/Table.vue'
import Button from '../button/Button.vue'
import Icon from '../icon/Icon.vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-variables/>
   */
  name: 'AkVariablesTable',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [Table.name]: Table,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Array}
     * @description
     */
    data: {
      type: Array,
      default: () => [],
    },

    /**
     * @type {Function}
     * @description
     */
    insert: {
      type: Function,
      default: () => {},
    },

    /**
     * @type {String}
     * @description
     */
    type: {
      type: String,
      default: 'lead',
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props) {
    /**
     * @param {Object} variable
     * @description Tries to pass the variable and the type through the
     * callback function.
     */
    const insertVariable = (variable) => {
      try {
        props.insert(props.type, variable)
      } catch (ex) {
        console.error(ex)
      }
    }

    return {
      insertVariable,
    }
  },
})
</script>
